import {ref} from "valtio";

import {EventEmitter} from "@/shared/event-emitter";

import type {IRouter, NavigateOptions} from "./router-bridge";

interface ServerRouterEvents {
    navigate: (path: string, options?: NavigateOptions) => void;
    replace: (path: string, options?: NavigateOptions) => void;
    back: () => void;
    forward: () => void;
    refresh: () => void;
}

/**
 * Server-side Router - full navigation using Next.js Router
 * Triggers server component re-render
 */
class ServerRouterClass implements IRouter {
    readonly events: EventEmitter<ServerRouterEvents>;

    constructor() {
        this.events = ref(new EventEmitter<ServerRouterEvents>()) as EventEmitter<ServerRouterEvents>;
    }

    /**
     * Full navigation - triggers server component re-render
     * Uses Next.js router.push()
     */
    navigate(path: string, options?: NavigateOptions): void {
        this.events.emit("navigate", path, options);
    }

    /**
     * Full replace - triggers server component re-render
     * Uses Next.js router.replace()
     */
    replace(path: string, options?: NavigateOptions): void {
        this.events.emit("replace", path, options);
    }

    back(): void {
        this.events.emit("back");
    }

    forward(): void {
        this.events.emit("forward");
    }

    refresh(): void {
        this.events.emit("refresh");
    }

    dispose(): void {
        this.events.removeAllListeners();
    }
}

export type ServerRouterInstance = ServerRouterClass;

export function ServerRouter(): ServerRouterInstance {
    return new ServerRouterClass();
}
